import * as React from "react";
import { useEffect, useState } from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { PensionArrangementAction } from "../Action/PensionArrangementValuationAction";
import { ArangementsDonutChart } from "./ArrangementsDonutChart";
import { CappedTable } from "./CappedTable";
import { FlexiTable } from "./FlexiTable";
import { NextIncomePayment } from "./NextIncomePayment";
import { PreRetirementTable } from "./PreRetirementTable";
import { ReviewFlexiList } from "./ReviewFlexiList";
import { ReviewTable } from "./ReviewTable";
import { TotalPayeIncome } from "./TotalPayeIncome";
import { Action } from "../../../../../../../Dashboard/Actions/Action";
import { PensionBenefitsAction } from "../../../../PensionBenefitsWizard/Actions/PensionBenefitsAction";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ProductOverviewSippTaxInformationAction } from "../Action/ProductOverviewSippTaxInformationAction";
import { DrawdownAnnualIncome } from "../../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownAnnualIncome";
import { PensionSubAccountSettings } from "../../../../../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { PensionSubAccountSettingsStore } from "../../../../../../Stroes/Variable";
import { useSubscribeToStore } from "../../../../../../../../react-core/Flux/Hooks/useSubscribeToStore";
import { ProductOverviewCrystallisationAction } from "../Action/ProductOverviewCrystallisationAction";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { InProgressDrawdownIncome } from "../../../../../../../../Wrap/Models/Domains/Drawdown/InProgressDrawdownIncome";
import { PensionLevelDrawdownIncome } from "../../../../../../../../Wrap/Models/Domains/Drawdown/PensionLevelDrawdownIncome";

//This can be edited to depending on API reqruiments later
interface IProductOverviewValuationAndIncomeProps {
    subAccountHierarchyId: string;
    subClAccountId: string;
    selectedProduct: SubAccountType;
    headaccount: ClientAccount;
    customerid: number;
}

class IChartData {
    label: string;
    value: Money;
    allocation: number;
    color: string;
}

export const ProductOverviewValuationAndIncome = (props: IProductOverviewValuationAndIncomeProps) => {
    const [valuationData, setValuationData] = useState(null);
    const [pensionArrangementDetailsData, setArrangementDetailsData] = useState(null);
    const [drawdownIncomeData, setDrawdownincomeData] = useState(null);
    const [InProgressDrawdownIncomeData, setInProgressDrawdownIncomeData] = useState<InProgressDrawdownIncome[]>(null);
    const [drawdownIncomeReviewDateData, setDrawdownIncomeReviewDateData] = useState(null);
    const [taxInfo, setTaxInfo] = useState(null);
    const [showRestrictionLightbox, setShowRestrictionLightbox] = useState(false);
    const [restrictionLightboxErrorMessage, setRestrictionLightboxErrorMessage] = useState(null);

    const [isPensionSubAccountSettingsLoading, setIsPensionSubAccountSettingsLoading] = useState<boolean>(false);
    const [pensionSubAccountSettings, setPensionSubAccountSettings] = useState<PensionSubAccountSettings>(PensionSubAccountSettingsStore.getPensionSubAccountSettings());

    useSubscribeToStore(PensionSubAccountSettingsStore, () => {
        const data = PensionSubAccountSettingsStore.getPensionSubAccountSettings();
        setPensionSubAccountSettings(data);
        setIsPensionSubAccountSettingsLoading(PensionSubAccountSettingsStore.isLoading());
    });

    useEffect(() => {
        const hierarchyIds = [props.subAccountHierarchyId];
        if ((props?.selectedProduct == SubAccountType.Npr || props?.selectedProduct == SubAccountType.JuniorSipp) && !valuationData) {
            PensionArrangementAction.GetPensionArrangementValuation(hierarchyIds, true, (data) => {
                setValuationData(data);
            });
        }
        return () => {
            setValuationData(null);
        };
    }, []);

    useEffect(() => {
        if (!pensionArrangementDetailsData) {
            PensionArrangementAction.GetPensionArrangementDetails(props.subAccountHierarchyId, false, (data) => {
                setArrangementDetailsData(data);
            });
        }
        return () => {
            setArrangementDetailsData(null);
        };
    }, []);

    useEffect(() => {
        if (!drawdownIncomeData) {
            Action.getDrawdownIncome(props.subAccountHierarchyId, (val) => {
                setDrawdownincomeData(val);
            });
        }
        return () => {
            setDrawdownincomeData(null);
        };
    }, []);

    useEffect(() => {        
        if (!InProgressDrawdownIncomeData) {
            Action.getInProgressDrawdownIncome(props.headaccount.HierarchyId, (val) => {
                setInProgressDrawdownIncomeData(val);
            });
        }
        return () => {
            setInProgressDrawdownIncomeData(null);
        };
    }, []);

    useEffect(() => {
        if (!drawdownIncomeReviewDateData) {
            PensionBenefitsAction.getDrawdownIncomeReviewDetails(props.headaccount.HierarchyId, (val) => {
                setDrawdownIncomeReviewDateData(val);
            });
        }
        return () => {
            setDrawdownIncomeReviewDateData(null);
        };
    }, []);

    useEffect(() => {
        if (props?.selectedProduct == SubAccountType.Npr || props?.selectedProduct == SubAccountType.JuniorSipp) {
            ProductOverviewSippTaxInformationAction.get(props.subAccountHierarchyId, (val) => {
                setTaxInfo(val);
            });
        }
    }, []);

    useEffect(() => {
        if (props.selectedProduct === SubAccountType.Npr || props.selectedProduct === SubAccountType.JuniorSipp) {
            ProductOverviewCrystallisationAction.loadPensionSubAccountSettings(props.subAccountHierarchyId);
        }
    }, [props.subAccountHierarchyId]);

    const getChartData = () => {
        if (!valuationData?.length || !pensionArrangementDetailsData?.length) {
            return [];
        }
        const colors = generateColor(valuationData.length);
        let data: Array<IChartData> = [];
        valuationData.forEach((val, index) => {
            const arrangement = pensionArrangementDetailsData.find((x) => x.Id === val.ArrangementId);
            if (!arrangement) return;
            let displayName = "";
            if (arrangement.Type === PensionArrangementType.Accumulation) {
                displayName = "Savings pot";
            }
            else if (arrangement.Type === PensionArrangementType.Capped) {
                displayName = "Capped drawdown";
            }
            else if (arrangement.Type === PensionArrangementType.Fad) {
                displayName = "Flexible drawdown";
            }
            let chart: IChartData = {
                label: displayName + " (" + val.ArrangementId + ")",
                value: val.DisplayAvailableValue,
                allocation: parseFloat(val.DisplayPercentage.toFixed(2)),
                color: colors[index],
            };
            data.push(chart);
        });
        return data;
    };

    const getPreretirementData = () => {
        if (!valuationData?.length || !pensionArrangementDetailsData?.length) {
            return [];
        }
        const preretirementData = pensionArrangementDetailsData.reduce((d, o) => {
            if (o.Type === PensionArrangementType.Accumulation) {
                const valuationForArrangement = valuationData.find((val) => val.ArrangementId === o.Id);

                const availableValue = valuationForArrangement ? valuationForArrangement.DisplayAvailableValue : null;

                d.push({
                    displayName: o.DisplayName,
                    arrangementis: o.Id,
                    credit: o.DisqualifyingPensionCredits ? "Yes" : "No",
                    date: o.DateCreated
                        ? JsonDateParser.getFormatDateString(new Date(o?.DateCreated), "dd/MM/yyyy")
                        : null,
                    availableValue: availableValue,
                });
            }
            return d;
        }, []);
        return preretirementData;
    };

    const getCappedData = () => {
        if (
            !valuationData?.length ||
            !pensionArrangementDetailsData?.length ||
            !drawdownIncomeData?.CappedArrangementsIncomeDetail?.length
        ) {
            return [];
        }
        const cappedData = pensionArrangementDetailsData.reduce((d, o) => {
            if (o.Type === PensionArrangementType.Capped) {
                const valuationForArrangement = valuationData.find((val) => val.ArrangementId === o.Id);
                const drawdownIncome = drawdownIncomeData.CappedArrangementsIncomeDetail.find(
                    (x) => x.ArrangementId === o.Id
                );
                const availableValue = valuationForArrangement ? valuationForArrangement.DisplayAvailableValue : null;

                d.push({
                    displayName: o.DisplayName,
                    arrangementis: o.Id,
                    credit: o.DisqualifyingPensionCredits ? "Yes" : "No",
                    drawdown: o.IsInherited ? "Yes" : "No",
                    taxable: o.IsTaxable ? "Yes" : "No",
                    date: o.DateCreated
                        ? JsonDateParser.getFormatDateString(new Date(o?.DateCreated), "dd/MM/yyyy")
                        : null,
                    dateclose: o.DateClosed
                        ? JsonDateParser.getFormatDateString(new Date(o?.DateClosed), "dd/MM/yyyy")
                        : null,
                    availableValue: availableValue,
                    nextGadReviewDate: drawdownIncome?.ReferencePeriodEndDate
                        ? JsonDateParser.getFormatDateString(
                              new Date(drawdownIncome?.ReferencePeriodEndDate),
                              "dd/MM/yyyy"
                          )
                        : null,
                });
            }
            return d;
        }, []);
        return cappedData;
    };

    const getFlexiData = () => {
        if (!valuationData?.length || !pensionArrangementDetailsData?.length) {
            return [];
        }
        const flexiData = pensionArrangementDetailsData.reduce((d, o) => {
            if (o.Type === PensionArrangementType.Fad) {
                const valuationForArrangement = valuationData.find((val) => val.ArrangementId === o.Id);

                const availableValue = valuationForArrangement ? valuationForArrangement.DisplayAvailableValue : null;

                d.push({
                    displayName: o.DisplayName,
                    arrangementis: o.Id,
                    credit: o.DisqualifyingPensionCredits ? "Yes" : "No",
                    drawdown: o.IsInherited ? "Yes" : "No",
                    taxable: o.IsTaxable ? "Yes" : "No",
                    convert: o.IsConvertedFromCapped ? "Yes" : "No",
                    dateconverted: o.DateConvertedFromCapped
                        ? JsonDateParser.getFormatDateString(new Date(o?.DateConvertedFromCapped), "dd/MM/yyyy")
                        : null,
                    date: o.DateCreated
                        ? JsonDateParser.getFormatDateString(new Date(o?.DateCreated), "dd/MM/yyyy")
                        : null,
                    dateclose: o.DateClosed
                        ? JsonDateParser.getFormatDateString(new Date(o?.DateClosed), "dd/MM/yyyy")
                        : null,
                    availableValue: availableValue,
                });
            }
            return d;
        }, []);
        return flexiData;
    };

    const generateColor = (num: number) => {
        const defaultColors = [
            "#2caffe",
            "#544fc5",
            "#00e272",
            "#fe6a35",
            "#6b8abc",
            "#d568fb",
            "#2ee0ca",
            "#fa4b42",
            "#feb56a",
            "#91e8e1",
        ];
        let colorSet = new Set<string>();

        while (colorSet.size < num) {
            defaultColors.forEach((color) => {
                if (colorSet.size < num) {
                    colorSet.add(color);
                }
            });
        }

        return Array.from(colorSet);
    };

    const hasNextIncomepayment = (income: PensionLevelDrawdownIncome) => {
        if (income?.AnnualIncome?.TargetSpecificArrangements) {
            return (income?.FlexiArrangementsIncomeDetail ?? []).some(x => x.AnnualAmount?.Amount?.Amount > 0) ||
                (income?.CappedArrangementsIncomeDetail ?? []).some(x => x.IncomeRemainingInCurrentYear?.Amount > 0) ||
                (income?.CappedArrangementsIncomeDetail ?? []).some(x => x.AnnualAmount?.Amount?.Amount > 0) //for capped ruture year income
        }
        else {
            return (
                income?.AnnualIncome?.GrossIncomePerPayment?.Amount > 0 ||
                income?.AnnualIncome?.AnnualAmount?.Amount?.Amount > 0 ||
                income?.AnnualIncome?.CurrentYearIncome?.Amount > 0
            );
        }
    };

    return (
        <>
            {showRestrictionLightbox && (
                <Lightbox
                    show={showRestrictionLightbox}
                    title={"Warning"}
                    contentAfterTitle={null}
                    onClose={() => setShowRestrictionLightbox(false)}
                    type={LightboxType.Modal}
                    unclosable={true}
                    noOverlay={false}
                    noAutofocus={true}
                    cssWrapper="is-default-lightbox is-narrow"
                >
                    <p>{restrictionLightboxErrorMessage}</p>

                    <button
                        className="btn primary"
                        onClick={() => setShowRestrictionLightbox(false)}
                    >
                        OK
                    </button>
                </Lightbox>
            )}
            <h1 className="sr-only">Valuation and income</h1>
            {pensionArrangementDetailsData?.length && (
                <>
                    <h2 className="mb-36">Valuation summary</h2>
                    <div className="panel-subtle panel-scrollable mb-50">
                        <ArangementsDonutChart data={getChartData()} />
                    </div>

                    <h2 className="mb-36">Valuation detail</h2>
                    <PreRetirementTable data={getPreretirementData()} />

                    <CappedTable data={getCappedData()} />

                    <FlexiTable data={getFlexiData()} />

                    <hr />
                </>
            )}

            <h2 className="mb-40">Income</h2>
            <div className="row wide-gutter">
                {drawdownIncomeData?.AnnualIncome && (
                    <div className="col-12 col-sm-6 col-equalise mb-50">
                        <div className="d-flex f-direction-column">
                            <TotalPayeIncome
                                subAccountHierarchyId={props.subAccountHierarchyId}
                                headaccount={props.headaccount}
                            />
                        </div>
                    </div>
                )}
                {(drawdownIncomeData?.AnnualIncome && InProgressDrawdownIncomeData?.length > 0 || hasNextIncomepayment(drawdownIncomeData)) && (
                    <div className="col-12 col-sm-6 col-equalise mb-50">
                        <div className="d-flex f-direction-column">
                            <NextIncomePayment
                                data={drawdownIncomeData}
                                InProgressDrawdownIncome={InProgressDrawdownIncomeData}
                                taxInfo={taxInfo}
                                headaccount={props.headaccount}
                                subAccountHierarchyId={props.subAccountHierarchyId}
                                customerid={props.customerid}
                                isPensionSubAccountSettingsLoading={isPensionSubAccountSettingsLoading}
                                pensionSubAccountSettings={pensionSubAccountSettings}
                                setShowRestrictionLightbox={setShowRestrictionLightbox}
                                setRestrictionLightboxErrorMessage={setRestrictionLightboxErrorMessage}
                            />
                        </div>
                    </div>
                )}
            </div>

            {drawdownIncomeData?.CappedArrangementsIncomeDetail?.length != 0 && (
                <>
                    <h3>Review</h3>
                    <div className="panel-subtle panel-scrollable mb-50 pt-10 pb-10">
                        <ReviewTable data={drawdownIncomeData?.CappedArrangementsIncomeDetail} />
                    </div>
                </>
            )}
            {/* {drawdownIncomeReviewDateData?.DrawdownIncomeReviewDetails && (
                <>
                    <h3>Review</h3>
                    <div className="row wide-gutter">
                        <div className="col-12 col-sm-6">
                            <ReviewFlexiList data={drawdownIncomeReviewDateData} />
                        </div>
                    </div>
                </>
            )} */}
        </>
    );
};
